<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Settings</h2>

    <div class="ecomerce-status">
      <!--      <div class="flex-center gap-2">-->
      <!--        <p>Page_Title:</p>-->
      <!--        <div class="status-holder" v-if="shopDetails.status">-->
      <!--          <span class="indicator"></span> <strong>Live</strong>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!-- Tabs Here -->
    <Tabs :tabs="tabs" @setActiveTab="setActiveTab($event)" />
    <transition name="slide-fade">
      <EcommerceSetting v-if="tabs[0].isActive" />
      <EcommercePaymentsTab v-if="tabs[1].isActive" />

      <!--      <EcommerceCustomCodeTab v-if="tabs[2].isActive" />-->
    </transition>
  </div>
</template>

<script>
import EcommerceSetting from './EcommerceSettingsTab'
import EcommercePaymentsTab from './EcommercePaymentsTab'
// import EcommerceCustomCodeTab from './EcommerceCustomCodeTab'
import { mapState } from 'vuex'
export default {
  name: 'EcommerceSettings',
  props: ['id'],

  data() {
    return {
      tabs: [
        { name: 'General', isActive: true },
        { name: 'Payments', isActive: false }
        // { name: 'Code', isActive: false }
      ]
    }
  },
  components: {
    Tabs: () => import('../Universal/Tabs'),
    EcommerceSetting,
    EcommercePaymentsTab
    // EcommerceCustomCodeTab
  },

  computed: {
    ...mapState({
      shopDetails: state => state.ecommerce.shopDetails
    })
  },
  methods: {
    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    }
  },

  created() {
    this.$store.dispatch('ecommerce/getStoreDetails')
  }
}
</script>

<style scoped lang="scss">
.ecomerce-status {
  display: flex;
  align-items: center;
  justify-content: end;

  p,
  strong {
    font-size: 0.875rem;
  }
}

.status-holder {
  display: flex;
  align-items: center;
  gap: 8px;
}

.indicator {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 60px;
  background-color: #68c67e;
  transform: scale(1);
  animation: pulse-holder 3s none;
  animation-delay: 300ms;
  animation-iteration-count: 1;
}

@keyframes pulse-holder {
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 rgba(30, 87, 29, 0.7);
    // box-shadow: rgba(104, 198, 126, 0.25);
  }

  70% {
    transform: scale(0.82);
    box-shadow: 0 0 0 10px rgba(18, 128, 60, 0.142);
    // box-shadow: rgba(3, 5, 3, 0.5);
  }

  100% {
    transform: scale(0.84);
    // box-shadow: rgba(5, 242, 154, 0.1);
    box-shadow: rgba(106, 227, 134, 0.5);
  }
}
</style>
